import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "Dropdown", "dropdownButtonText", "dropdownProps"];
import { Collapser } from '../Collapser/Collapser';
import { Dropdown } from '../Dropdown';
import { List } from '../List';
import I18n from 'I18n';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCollapserWrapper = styled.div.withConfig({
  displayName: "ButtonCollapser__StyledCollapserWrapper"
})(({
  theme
}) => ({
  // Target the span elements that Collapser creates (nested inside View)
  '& > * > span + span': {
    marginInlineStart: theme.space['300']
  }
}));
/**
 * Renders a row of buttons, collapsing them into a dropdown when there isn't
 * room to show them all and expanding them back when room returns.
 *
 * Known limitation: when ButtonCollapser is a flex child, it does not expand back
 * to the buttons after collapsing, even if the container has room. As a flex item
 * it is sized to its content, so its box stays at the dropdown's width.
 */
export const ButtonCollapser = _ref => {
  let {
      children,
      Dropdown: DropdownComponent = Dropdown,
      dropdownButtonText = I18n.text('ui.UIButtonCollapser.dropdownLabel'),
      dropdownProps
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledCollapserWrapper, {
    children: /*#__PURE__*/_jsx(Collapser, Object.assign({}, rest, {
      fallback: /*#__PURE__*/_jsx(DropdownComponent, Object.assign({
        buttonText: dropdownButtonText
      }, dropdownProps, {
        children: /*#__PURE__*/_jsx(List, {
          wrapChildren: true,
          children: children
        })
      })),
      children: children
    }))
  });
};
ButtonCollapser.displayName = 'ButtonCollapser';